var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.popperClass},[(!_vm.disabled&&(_vm.isInputModifiedByMyself||_vm.isInputModified))?_c('div',{staticClass:"text"},[_vm._v("此内容已修改")]):_vm._e(),_c('div',{staticClass:"content-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }